import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PostgrestBuilder } from './types';
/**
 * Post-filters (transforms)
 */

var PostgrestTransformBuilder = /*#__PURE__*/function (_PostgrestBuilder) {
  _inherits(PostgrestTransformBuilder, _PostgrestBuilder);

  var _super = _createSuper(PostgrestTransformBuilder);

  function PostgrestTransformBuilder() {
    _classCallCheck(this, PostgrestTransformBuilder);

    return _super.apply(this, arguments);
  }

  _createClass(PostgrestTransformBuilder, [{
    key: "select",
    value:
    /**
     * Performs vertical filtering with SELECT.
     *
     * @param columns  The columns to retrieve, separated by commas.
     */
    function select() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
      // Remove whitespaces except when quoted
      var quoted = false;
      var cleanedColumns = columns.split('').map(function (c) {
        if (/\s/.test(c) && !quoted) {
          return '';
        }

        if (c === '"') {
          quoted = !quoted;
        }

        return c;
      }).join('');
      this.url.searchParams.set('select', cleanedColumns);
      return this;
    }
    /**
     * Orders the result with the specified `column`.
     *
     * @param column  The column to order on.
     * @param ascending  If `true`, the result will be in ascending order.
     * @param nullsFirst  If `true`, `null`s appear first.
     * @param foreignTable  The foreign table to use (if `column` is a foreign column).
     */

  }, {
    key: "order",
    value: function order(column) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$ascending = _ref.ascending,
          ascending = _ref$ascending === void 0 ? true : _ref$ascending,
          _ref$nullsFirst = _ref.nullsFirst,
          nullsFirst = _ref$nullsFirst === void 0 ? false : _ref$nullsFirst,
          foreignTable = _ref.foreignTable;

      var key = typeof foreignTable === 'undefined' ? 'order' : "".concat(foreignTable, ".order");
      var existingOrder = this.url.searchParams.get(key);
      this.url.searchParams.set(key, "".concat(existingOrder ? "".concat(existingOrder, ",") : '').concat(column, ".").concat(ascending ? 'asc' : 'desc', ".").concat(nullsFirst ? 'nullsfirst' : 'nullslast'));
      return this;
    }
    /**
     * Limits the result with the specified `count`.
     *
     * @param count  The maximum no. of rows to limit to.
     * @param foreignTable  The foreign table to use (for foreign columns).
     */

  }, {
    key: "limit",
    value: function limit(count) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          foreignTable = _ref2.foreignTable;

      var key = typeof foreignTable === 'undefined' ? 'limit' : "".concat(foreignTable, ".limit");
      this.url.searchParams.set(key, "".concat(count));
      return this;
    }
    /**
     * Limits the result to rows within the specified range, inclusive.
     *
     * @param from  The starting index from which to limit the result, inclusive.
     * @param to  The last index to which to limit the result, inclusive.
     * @param foreignTable  The foreign table to use (for foreign columns).
     */

  }, {
    key: "range",
    value: function range(from, to) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          foreignTable = _ref3.foreignTable;

      var keyOffset = typeof foreignTable === 'undefined' ? 'offset' : "".concat(foreignTable, ".offset");
      var keyLimit = typeof foreignTable === 'undefined' ? 'limit' : "".concat(foreignTable, ".limit");
      this.url.searchParams.set(keyOffset, "".concat(from)); // Range is inclusive, so add 1

      this.url.searchParams.set(keyLimit, "".concat(to - from + 1));
      return this;
    }
    /**
     * Sets the AbortSignal for the fetch request.
     */

  }, {
    key: "abortSignal",
    value: function abortSignal(signal) {
      this.signal = signal;
      return this;
    }
    /**
     * Retrieves only one row from the result. Result must be one row (e.g. using
     * `limit`), otherwise this will result in an error.
     */

  }, {
    key: "single",
    value: function single() {
      this.headers['Accept'] = 'application/vnd.pgrst.object+json';
      return this;
    }
    /**
     * Retrieves at most one row from the result. Result must be at most one row
     * (e.g. using `eq` on a UNIQUE column), otherwise this will result in an
     * error.
     */

  }, {
    key: "maybeSingle",
    value: function maybeSingle() {
      this.headers['Accept'] = 'application/vnd.pgrst.object+json';
      this.allowEmpty = true;
      return this;
    }
    /**
     * Set the response type to CSV.
     */

  }, {
    key: "csv",
    value: function csv() {
      this.headers['Accept'] = 'text/csv';
      return this;
    }
  }]);

  return PostgrestTransformBuilder;
}(PostgrestBuilder);

export { PostgrestTransformBuilder as default };